function initRecommendedSlider(section) {
  if (!section || section.dataset.sliderReady === 'true') return;

  const track = section.querySelector('[data-track]');
  const progress = section.querySelector('[data-progress]');
  const prevButtons = section.querySelectorAll('[data-prev]');
  const nextButtons = section.querySelectorAll('[data-next]');

  if (!track) return;

  section.dataset.sliderReady = 'true';

  function getStep() {
    const firstCard = track.querySelector('.product-card');
    if (!firstCard) return 280;

    const trackStyles = window.getComputedStyle(track);
    const gap = parseFloat(trackStyles.gap || trackStyles.columnGap || 0) || 0;

    return firstCard.getBoundingClientRect().width + gap;
  }

  function updateProgress() {
    if (!progress) return;

    const progressWrap = progress.parentElement;
    if (!progressWrap) return;

    const maxScroll = track.scrollWidth - track.clientWidth;
    const wrapWidth = progressWrap.clientWidth;

    if (maxScroll <= 0 || wrapWidth <= 0) {
      progress.style.width = '100%';
      progress.style.transform = 'translateX(0px)';
      return;
    }

    const visibleRatio = track.clientWidth / track.scrollWidth;
    const minBarPx = 24;
    const barWidthPx = Math.max(minBarPx, wrapWidth * visibleRatio);
    const maxMovePx = wrapWidth - barWidthPx;

    const scrollRatio = Math.min(1, Math.max(0, track.scrollLeft / maxScroll));
    const movePx = maxMovePx * scrollRatio;

    progress.style.width = `${barWidthPx}px`;
    progress.style.transform = `translateX(${movePx}px)`;
  }

  prevButtons.forEach((button) => {
    button.addEventListener('click', () => {
      track.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });
  });

  nextButtons.forEach((button) => {
    button.addEventListener('click', () => {
      track.scrollBy({ left: getStep(), behavior: 'smooth' });
    });
  });

  track.addEventListener('scroll', updateProgress, { passive: true });
  window.addEventListener('resize', updateProgress);

  updateProgress();
}

function initAllRecommendedSliders() {
  document.querySelectorAll('.recommended-products').forEach((section) => {
    initRecommendedSlider(section);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initAllRecommendedSliders();

  const observer = new MutationObserver(() => {
    initAllRecommendedSliders();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});